import React, { useState } from "react";
import { Container, Modal } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

const IaGenetariva = () => {
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const handleShow = (url) => {
    setVideoUrl(url);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoUrl("");
  };

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: El Gran Salto: De Predecir a Crear",
      url: `${videoBaseURL}GAI1.mp4`,
      conceptoclave: [
        "La diferencia fundamental entre la IA tradicional (predictiva) y la IA Generativa (creativa).",
      ],
      analogia: [
        'La IA Predictiva es un sensor (te da un "Sí/No" o un "Valor"). La IA Generativa es un simulador o un generador de señales (crea un resultado nuevo).'
      ],
      aplicacion: "IA Predictiva (AIOps): Te dice qué servidor está a punto de fallar (basado en métricas).\nIA Generativa (DevOps): Te escribe el script de Python o Ansible para configurar el nuevo servidor que lo reemplazará."
    },
    {
      nombre: "Video 2: ¿Cómo Funciona un LLM? (El Motor de Texto)",
      url: `${videoBaseURL}GAI2.mp4`,
      conceptoclave: [
        'La magia de la "predicción de la siguiente palabra" (Next-Token Prediction) y la arquitectura "Transformer".',
      ],
      analogia: [
        "El autocompletar de tu teléfono, pero con un cerebro a nivel de doctorado entrenado con todo Internet."
      ],
      aplicacion: 'El LLM ha sido entrenado con código de GitHub y manuales de Cisco. "Entiende" la sintaxis de un log de error o un script de Python, permitiéndole explicar un log críptico o generar un script funcional desde cero.'
    },
    {
      nombre: "Video 3: ¿Cómo Funciona GenAI para Imágenes? (El Motor Visual)",
      url: `${videoBaseURL}GAI3.mp4`,
      conceptoclave: [
        'El modelo de "Difusión" (quitar ruido).',
      ],
      analogia: [
        "Ver una señal clara emergiendo del ruido en un analizador de espectro (el modelo aprende a invertir el ruido)."
      ],
      aplicacion: "Generación de datos sintéticos (ej. crear 1000 muestras de tráfico de red que simulen un ataque DDoS; o generar diagramas de topología de red)."
    },
    {
      nombre: 'Video 4: El "Copiloto" (Tu Nuevo Compañero de Trabajo)',
      url: `${videoBaseURL}GAI4.mp4`,
      conceptoclave: [
        "La IA Generativa como un asistente experto para tareas diarias.",
      ],
      analogia: [
        "Es un ingeniero junior (L1) instantáneo. Tiene todo el conocimiento de los libros (Internet) pero cero experiencia de tu red. Es perfecto para ejecutar tareas definidas (escribir scripts, resumir logs) bajo tu supervisión (tu prompt)."
      ],
      aplicacion: "Generación de scripts (Python, Ansible), explicación de errores de log y redacción de documentación de incidentes (RCA)."
    },
    {
      nombre: "Video 5: RAG (El Cerebro que Sabe de Tu Red)",
      url: `${videoBaseURL}GAI5.mp4`,
      conceptoclave: [
        'Retrieval-Augmented Generation" (RAG). Cómo hacer que el LLM use tus documentos privados (runbooks, esquemas de red)',
      ],
      analogia: [
        'Es un LLM con "acceso a la biblioteca" (tu base de datos de conocimiento) para responder con hechos, no solo con su entrenamiento general.'
      ],
      aplicacion: 'Un ingeniero de Nivel 1 (N1) le pregunta al chatbot RAG: "¿Cuál es el procedimiento de escalamiento para el Cliente-X si falla su firewall primario?". El chatbot (usando RAG) encuentra el runbookinterno y da la respuesta correcta de la empresa, no una respuesta genérica de Internet.'
    },
    {
      nombre: 'Video 6: El Futuro es "Agéntico" (La IA que Actúa)',
      url: `${videoBaseURL}GAI6.mp4`,
      conceptoclave: [
        "La IA Agéntica. La diferencia entre GenAI (que planifica) y un Agente (que ejecuta).",
      ],
      analogia: [
        'IA Generativa (el Copiloto): Es el experto que te dice: "Parece que el firewall está bloqueando el puerto 80, deberías revisar la Regla #45".\nIA Agéntica (el Piloto): Es el sistema que recibe ese plan, ejecuta el comando SSH, verifica la Regla #45, y aplica el parche él mismo.'
      ],
      aplicacion: "El Agente que no solo te dice cómo arreglar el problema, sino que toma el ticket, ejecuta el script de diagnóstico y aplica el parche en el firewall."
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">IA Generativa para Ingenieras e Ingenieros de Operaciones de TI</h1>
        </div>

        <div className="orgproc-grid-2col">
          {videos.map((video, idx) => (
            <div className="orgproc-card" key={video.nombre}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Video #{idx + 1}</div>
                <div className="orgproc-card-title">{video.nombre}</div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Concepto Clave</div>
                  <ul className="orgproc-card-list">
                    {video.conceptoclave.flatMap((item) => item.split("\n")).map((linea, i) => (
                      <li key={i}>{linea}</li>
                    ))}
                  </ul>
                </div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Analogía</div>
                  <ul className="orgproc-card-list">
                    {video.analogia.flatMap((item) => item.split("\n")).map((linea, i) => (
                      <li key={i}>{linea}</li>
                    ))}
                  </ul>
                </div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Aplicación</div>
                  <p className="orgproc-card-desc">
                    {(video.aplicacion || "—").split("\n").map((linea, i) => (
                      <React.Fragment key={i}>
                        {i > 0 && <br />}
                        {linea}
                      </React.Fragment>
                    ))}
                  </p>
                </div>

                <div className="orgproc-card-actions">
                  <button
                    type="button"
                    className="orgproc-card-btn"
                    onClick={() => handleShow(video.url)}
                  >
                    Reproducir Video →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>

      {/* Modal para reproducir video */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Reproducción de Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default IaGenetariva;
